module.exports = __webpack_public_path__ + "media/images/mailer/icon-twitter-footer-35d87c18aaf16b1fc016cba2de17ad37.svg";